import React from 'react';
import { Skeleton } from 'antd';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { globalConst, isEmptyArr } from 'modules/global';

import { EmptyData, Visible } from 'components';

import { ITopUser } from '../models';

interface IProps {
  data: ITopUser[] | undefined;
  loading: boolean;
  testCount: string | undefined;
}

const getBallColor = (ball: number, testCount: string | undefined) => {
  if (Number(testCount) === 0) return 'bg-gray-50 text-gray-500';

  const percentage = Math.round((ball / Number(testCount)) * 100);

  if (percentage >= 90) return 'bg-green-50 text-green-500';
  if (percentage >= 70) return 'bg-blue-50 text-blue-500';
  if (percentage >= 50) return 'bg-yellow-50 text-yellow-500';
  if (percentage >= 30) return 'bg-orange-50 text-orange-500';
  return 'bg-red-50 text-red-500';
};

const TestFaolIshtrokchilar = ({ data, loading, testCount }: IProps) => {
  const t = useTranslations();

  return (
    <>
      <div className="max-h-58 min-h-58 space-y-3 overflow-auto pr-2">
        <Visible
          if={loading}
          else={
            <Visible
              if={isEmptyArr(data)}
              else={
                <div>
                  <div className="mb-3 text-xs font-medium text-gray-500">{t('faol_ishtirokchilar')}</div>
                  {data?.map(user => (
                    <div key={user.id} className="flex items-center justify-between space-y-2">
                      <Link href={`${globalConst.pageNames.CABINET}/${user.id}`} className="flex items-center gap-1 font-medium">
                        <Image
                          src={user.image || '/images/default-user.png'}
                          alt="DEFAULT"
                          width={28}
                          height={28}
                          title='Foydalanuvchining default rasmi'
                          loading="lazy"
                          className="max-h-7 min-h-7 rounded-full object-cover"
                        />
                        <span className='text-black'>{user.name}</span>
                      </Link>
                      <div className={`rounded-md px-3 py-1 text-xs font-medium ${getBallColor(user.ball, testCount)}`}>
                        {user.ball} {t('ball')}
                      </div>
                    </div>
                  ))}
                </div>
              }
            >
              <EmptyData height="40" title={t('hozircha_faol_ishtirokchilar_yoq')} />
            </Visible>
          }
        >
          {Array.from({ length: 5 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className="flex items-center justify-between">
              <div className="flex gap-3">
                <Skeleton.Avatar className="!h-6 !w-6" active />
                <Skeleton.Button active className="!w-30 mt-1 !h-3" />
              </div>
              <Skeleton.Button active className="!h-5" />
            </div>
          ))}
        </Visible>
      </div>
    </>
  );
};

export default TestFaolIshtrokchilar;
